import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { useNavigate } from 'react-router-dom';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
  const profileFilter = chooseProfileFilter();

  const navigate = useNavigate();

  const pathFrontEnd = '/fileemployeepayments/';
  const paths = {
    pathAdd: pathFrontEnd + 'add',
    pathEdit: pathFrontEnd + 'edit',
    pathView: pathFrontEnd + 'view',
    endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
    endpointDelete: `${config.endpoints.backend}fileemployeepayments/delete`,
    endpoint: config.endpoints.backend + 'fileemployeepayments/getall'
  }

  const filters = {
    validateOnChange: true,
    showGoBackButton: false,
    showSubmitButton: false,
    handleSubmit: loadData,
    fields: [
      {
        name: 'pdc_entity_id',
        type: 'select',
        label: 'Entidade',
        options: [],
        optionsEndpoint: {
          endpoint: paths.endpointGetAllEntities,
          label: 'corporate_name',
          value: 'id',
          params: {
            filter: {
              ...profileFilter
            }
          }
        },
        validations: {
          required: false
        },
        columnSize: 3,
      },
      {
        name: 'competency',
        type: 'month',
        label: 'Competência',
        validations: {
          required: false
        },
        columnSize: 3
      },
      {
        name: 'filtro',
        type: 'submit',
        label: 'Pesquisar',
        columnSize: 1
      },
      {
        name: 'reset',
        type: 'reset',
        label: 'Limpar',
        columnSize: 2
      },
    ]
  }

  let list = {
    labelTitle: 'Lista de Folhas de Pagamentos',
    labelTitleButtonAdd: 'Importar nova folha de pagamentos',
    fieldsShowOnDelete: ['competency_date'],
    showPrintButtons: true,
    canEdit: false,
    canView: false,
    formFilters: !profileFilter.pdc_entity_id ? filters : null,
    filter: {
      ...profileFilter
    },
    columns: [
      {
        name: 'entity_name',
        label: 'Entidade',
      },
      {
        name: 'competency_date',
        label: 'Competência',
      }
    ],
    columnsButtons: [
      {
        buttons: [
          {
            width: '10%',
            label: 'Pagamentos',
            icon: 'fas fa-eye',
            onClick: item => {
              navigate(`${pathFrontEnd}listpayments/${item.id}`)
            }
          }
        ]
      }
    ]
  };

  list = { ...list, ...paths };

  return (
    <div>
      <CustomListContainer
        pathAdd={list.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
      />
    </div>
  );
}
export default List;
